// Общий каркас всех защищённых экранов (Этап 6, docs/PLAN.md) — верхняя панель с навигацией и
// выходом, дочерний экран рендерится через <Outlet/>. Раздел 6 (возвраты) добавит сюда свой
// пункт навигации по мере реализации.
import { NavLink, Outlet } from "react-router-dom";

import { useAuthStore } from "../store/authStore";

export function AdminLayout() {
  const logout = useAuthStore((state) => state.logout);

  return (
    <div>
      <div className="top-bar screen" style={{ paddingBottom: 0 }}>
        <nav style={{ display: "flex", gap: 16, alignItems: "center" }}>
          <strong>avappbot</strong>
          <NavLink to="/users" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
            Пользователи
          </NavLink>
          <NavLink to="/plans" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
            Тарифы
          </NavLink>
          <NavLink to="/promo-codes" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
            Промокоды
          </NavLink>
        </nav>
        {/* В правом углу (как раньше), но текстом того же стиля, что и пункты меню слева
            (запрос пользователя, 2026-08-21) — button.nav-link в theme.css сбрасывает вид
            кнопки под остальные NavLink. */}
        <button className="nav-link" onClick={logout}>
          Выйти
        </button>
      </div>
      <Outlet />
    </div>
  );
}
